import type { Invite } from './families'

const DAY = 24 * 60 * 60 * 1000

const ago = (n: number) => (n === 0 ? 'today' : n === 1 ? 'yesterday' : `${n} days ago`)

// Where an invite stands, in a few words: "Sent 2 days ago · works 5 more days", or "Link ran out 3 days ago".
export function inviteState(invite: Pick<Invite, 'sentAt' | 'expiresAt'>, now: number) {
  if (invite.expiresAt <= now) {
    return { expired: true, said: `Link ran out ${ago(Math.floor((now - invite.expiresAt) / DAY))}` }
  }
  const sent = Math.max(0, Math.floor((now - invite.sentAt) / DAY))
  const left = Math.ceil((invite.expiresAt - now) / DAY)
  return { expired: false, said: `Sent ${ago(sent)} · works ${left} more ${left === 1 ? 'day' : 'days'}` }
}

// An invite waiting for the signed-in person, as GET /api/invites lists it.
export type WaitingInvite = {
  id: string
  family: string
  kind: 'family' | 'casual'
  from: string
  // The account that sent it.
  fromId: string
  person: { id: string; name: string; born: string | null; portrait: string | null } | null
  home: string | null
}

// "Not now" on waiting invites lasts until the app is next opened, so an invite is never lost, only set aside.
const LATER = 'gf-invites-later'

export function setAside(): string[] {
  try {
    const parsed: unknown = JSON.parse(sessionStorage.getItem(LATER) ?? '[]')
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function setAsideNow(ids: string[]) {
  try {
    sessionStorage.setItem(LATER, JSON.stringify([...new Set([...setAside(), ...ids])]))
  } catch {
    // Without storage the invites simply show again next time.
  }
}
